export const TEAM_IDENTITY_BADGE_SIZE = {
  market: {
    mobileBadge: 56,
    tabletBadge: 60,
  },
  portfolio: {
    cardBadge: 58,
    tableBadge: 32,
    worldCupTableBadge: 40,
  },
  picker: {
    badge: 48,
    worldCupBadge: 46,
    bracketBadge: 42,
    worldCupBracketBadge: 44,
  },
} as const;

export const TEAM_IDENTITY_NAME_CLASS = {
  marketMobile:
    "line-clamp-2 font-display text-[19px] font-bold uppercase leading-[1.05] tracking-[0.035em] text-foreground",
  marketTablet:
    "line-clamp-2 font-display text-[24px] font-bold uppercase leading-[1.04] tracking-[0.035em] text-foreground",
  portfolioCard:
    "min-w-0 truncate font-display text-[20px] font-bold uppercase leading-none tracking-[0.04em] text-foreground md:self-center md:text-[24px]",
  pickerTile:
    "block truncate font-display text-base font-bold uppercase leading-none tracking-[0.035em] text-foreground md:text-[17px]",
  pickerBracketTeam:
    "min-w-0 truncate font-display text-[13px] font-bold uppercase leading-none tracking-[0.035em] text-foreground md:text-[14px]",
} as const;
